"use strict";

exports.__esModule = true;
exports.viewPorts = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _snapdragonLogo = _interopRequireDefault(require("./snapdragon-logo"));

var _qLogo = _interopRequireDefault(require("./q-logo"));

var _qualcommLogo = _interopRequireDefault(require("./qualcomm-logo"));

var _filters = require("./filters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// **** Filters for chip background effects, drop shadows and bevels.  **** //
var filters = {
  "38": _filters.Filters38,
  "70": _filters.Filters70,
  "90": _filters.Filters90,
  "120": _filters.Filters120
};
var chipSetFont = {
  "70": {
    fontSize: 10,
    fontWeight: 400,
    letterSpacing: 1.125
  },
  "90": {
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: 0.7
  },
  "120": {
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.84
  }
};
var field2Font = {
  "70": {
    fontSize: 7,
    fontWeight: 400,
    letterSpacing: 0.7875
  },
  "90": {
    fontSize: 10,
    fontWeight: 400,
    letterSpacing: 0.7
  },
  "120": {
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: 0.6
  }
};
var numberFont = {
  "70": {
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 1.575
  },
  "90": {
    fontSize: 22,
    fontWeight: 400,
    letterSpacing: 1.54
  },
  "120": {
    fontSize: 28,
    fontWeight: 400,
    letterSpacing: 1.4
  }
};
var snapdragonFont = {
  "38": {},
  "70": {
    fontSize: 7,
    fontWeight: 400,
    letterSpacing: 0.3
  },
  "90": {
    fontSize: 11,
    fontWeight: 400,
    letterSpacing: 0.4
  },
  "120": {
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 0.3
  }
};
var viewPorts = {
  "38": {
    height: "46px",
    viewBox: "0 0 46 46",
    width: "46px"
  },
  "70": {
    height: "105px",
    viewBox: "0 0 115 105",
    width: "115px"
  },
  "90": {
    height: "125px",
    viewBox: "0 0 135 125",
    width: "135px"
  },
  "120": {
    height: "120px",
    viewBox: "0 0 120 120",
    width: "120px"
  }
};
exports.viewPorts = viewPorts;
var field1Y = {
  "38": 0,
  "70": 19,
  "90": 24,
  "120": 30
};
var field2Y = {
  "38": 0,
  "70": 29,
  "90": 36,
  "120": 45
};
var qcLogoY = {
  "38": 0,
  "70": 39,
  "90": 53,
  "120": 71
};
var field4Y = {
  "38": 0,
  "70": 13,
  "90": 16,
  "120": 19
};
var subtitleY = {
  "38": 0,
  "70": 22,
  "90": 26,
  "120": 36
};
var field3aY = {
  "38": 0,
  "70": 60,
  "90": 82,
  "120": 110
};
var lineSpacing = {
  "38": 0,
  "70": 8,
  "90": 12,
  "120": 18
};
var propTypes = {
  /** A string to set text shown large in top right  */
  field1: _propTypes.string,

  /** A string to set text shown under large string in top right  */
  field2: _propTypes.string,

  /** A string to set text shown in bottom right. First line if size is 38  */
  field3a: _propTypes.string,

  /** A string to set text shown in bottom right. Second line if size is 38  */
  field3b: _propTypes.string,

  /** A string to set text shown in top right */
  field4: _propTypes.string,

  /** A boolean to set whether the Q logo is shown */
  showQLogo: _propTypes.bool,

  /** A boolean to set whether the Qualcomm logo is shown */
  showQualcommLogo: _propTypes.bool,

  /** A boolean to set whether the snapdragon logo is shown */
  showSnapdragonLogo: _propTypes.bool,

  /** Size of chip  */
  size: (0, _propTypes.oneOf)(["38", "70", "90", "120"]).isRequired,

  /** Subtitle shown just below Qualcomm logo if shown  */
  subtitle: _propTypes.string,

  /** Second line of subtitle shown just below Qualcomm logo if shown  */
  subtitle2: _propTypes.string
};
var defaultProps = {
  field1: "",
  field2: "",
  field3a: "",
  field3b: "",
  field4: "",
  showQLogo: false,
  showQualcommLogo: false,
  showSnapdragonLogo: false,
  subtitle: "",
  subtitle2: ""
};

var Chip = function Chip(_ref) {
  var field1 = _ref.field1,
      field2 = _ref.field2,
      field3a = _ref.field3a,
      field3b = _ref.field3b,
      field4 = _ref.field4,
      showSnapdragonLogo = _ref.showSnapdragonLogo,
      showQLogo = _ref.showQLogo,
      showQualcommLogo = _ref.showQualcommLogo,
      size = _ref.size,
      subtitle = _ref.subtitle,
      subtitle2 = _ref.subtitle2;
  var radius = size === "38" ? 2 : 3;
  var FitlersConstructor = filters[size];
  var mainTranslateY = showSnapdragonLogo ? qcLogoY[size] : 7;
  var showQualcommLogoComp = showQualcommLogo && (size !== "38" || !showSnapdragonLogo);
  var showQLogoComp = showQLogo && !showQualcommLogo && !showSnapdragonLogo;
  var numberSize = parseInt(size, 10);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    height: size + "px",
    style: {
      overflow: "visible"
    },
    viewBox: "0 0 " + size + " " + size,
    width: size + "px",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("rect", {
    height: numberSize,
    id: "ChipPath-1" + size,
    rx: radius,
    width: numberSize,
    x: "0",
    y: "0"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    height: numberSize - 2,
    id: "ChipPath-5" + size,
    rx: 2,
    width: numberSize - 2,
    x: "1",
    y: "1"
  }), /*#__PURE__*/_react["default"].createElement(FitlersConstructor, null), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "ChipPath-7" + size,
    points: "0 2.28266359e-05 28.4412378 2.28266359e-05 28.4 38 0 38"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "ChipPath-9" + size,
    points: "0 6.84799077e-05 24.4153518 6.84799077e-05 24.4 38 0 38"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Chip",
    transform: "translate(2.0, 2.0)"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "black",
    fillOpacity: "1",
    filter: "url(#ChipFilter-2" + size + ")",
    xlinkHref: "#ChipPath-1" + size
  }), /*#__PURE__*/_react["default"].createElement("use", {
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#ChipPath-1" + size
  }), /*#__PURE__*/_react["default"].createElement("use", {
    fill: "black",
    fillOpacity: "1",
    filter: "url(#ChipFilter-3" + size + ")",
    xlinkHref: "#ChipPath-1" + size
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "ChipGradient",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0%",
    stopColor: "#4C4B4B"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "100%",
    stopColor: "#151E23"
  }))), size === "38" ? /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "url(#ChipGradient)",
    height: numberSize - 1,
    id: "Glare",
    rx: radius,
    stroke: "#222222",
    width: numberSize - 1,
    x: "0.5",
    y: "0.5"
  }), field3a && field3b && /*#__PURE__*/_react["default"].createElement("text", {
    fill: "#FFFFFF",
    fontSize: "7",
    fontWeight: "400",
    letterSpacing: "0.7"
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    textAnchor: "end",
    x: numberSize - 5,
    y: "26"
  }, field3a), /*#__PURE__*/_react["default"].createElement("tspan", {
    textAnchor: "end",
    x: numberSize - 5,
    y: "33"
  }, field3b))) : /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Glare2"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "url(#ChipGradient)",
    fillRule: "evenodd",
    xlinkHref: "#ChipPath-5" + size
  }), /*#__PURE__*/_react["default"].createElement("use", {
    fill: "black",
    filter: "url(#ChipFilter-6" + size + ")",
    xlinkHref: "#ChipPath-5" + size
  })), /*#__PURE__*/_react["default"].createElement("text", _extends({}, chipSetFont[size], {
    fill: "#FFFFFF"
  }), /*#__PURE__*/_react["default"].createElement("tspan", {
    textAnchor: "end",
    x: numberSize - 8,
    y: field3aY[size]
  }, field3a && "" + field3a, field3b && "" + field3b), field4 && /*#__PURE__*/_react["default"].createElement("tspan", {
    textAnchor: "end",
    x: numberSize - 8,
    y: field4Y[size]
  }, field4)), field1 && /*#__PURE__*/_react["default"].createElement("text", _extends({}, numberFont[size], {
    fill: "#FFFFFF"
  }), /*#__PURE__*/_react["default"].createElement("tspan", {
    textAnchor: "end",
    x: numberSize - 8,
    y: field1Y[size]
  }, field1)), field2 && /*#__PURE__*/_react["default"].createElement("text", _extends({}, field2Font[size], {
    fill: "#FFFFFF"
  }), /*#__PURE__*/_react["default"].createElement("tspan", {
    textAnchor: "end",
    x: numberSize - 8,
    y: field2Y[size]
  }, field2))), /*#__PURE__*/_react["default"].createElement("g", {
    transform: size !== "38" ? "translate(8.0, " + mainTranslateY + ")" : ""
  }, showQualcommLogoComp && /*#__PURE__*/_react["default"].createElement(_qualcommLogo["default"], {
    showSnapdragonLogo: showSnapdragonLogo,
    size: size
  }), size === "38" ? null : /*#__PURE__*/_react["default"].createElement("g", null, subtitle && /*#__PURE__*/_react["default"].createElement("text", _extends({}, snapdragonFont[size], {
    fill: "#FFFFFF"
  }), /*#__PURE__*/_react["default"].createElement("tspan", {
    x: 0,
    y: subtitleY[size]
  }, subtitle)), subtitle2 && /*#__PURE__*/_react["default"].createElement("text", _extends({}, snapdragonFont[size], {
    fill: "#FFFFFF"
  }), /*#__PURE__*/_react["default"].createElement("tspan", {
    x: 0,
    y: subtitleY[size] + lineSpacing[size]
  }, subtitle2)))), showSnapdragonLogo && /*#__PURE__*/_react["default"].createElement(_snapdragonLogo["default"], {
    size: size
  }), showQLogoComp && /*#__PURE__*/_react["default"].createElement(_qLogo["default"], {
    size: size
  })));
};

Chip.propTypes = propTypes;
Chip.defaultProps = defaultProps;
Chip.displayName = "Modules.Chip";
var _default = Chip;
exports["default"] = _default;